import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  getRoleByGroupLibAsync,
  getRolesLibAsync,
  deleteRoleLibAsync,
  createRoleLibAsync,
  assignRoleToGroupLibAsync,
} from 'src/redux/async/libraries/roleThunks'

const initialState = {
  rolesByGroupData: [],
  allRolesData:[],
  createRoleData: [],
  assignRoleData:[],
  roleDeleteData: [],
  roleLoader: false,
  error: '',
    // roleCreationStatus: 'idle',
};

const roleSlice = createSlice({
  name: 'roleLibraries',
  initialState,
  reducers: {},
  extraReducers: (builder) => {

      // Fetch roles by group
      builder.addMatcher(isAnyOf(getRoleByGroupLibAsync.pending), (state) => {
        state.roleLoader = true
      })
      builder.addMatcher(isAnyOf(getRoleByGroupLibAsync.fulfilled), (state, action) => {
        state.roleLoader = false
        state.rolesByGroupData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(getRoleByGroupLibAsync.rejected), (state, action) => {
        state.roleLoader = false
        state.error = action.payload
      })


      // Fetch all roles
      builder.addMatcher(isAnyOf(getRolesLibAsync.pending), (state) => {
        state.roleLoader = true
      })
      builder.addMatcher(isAnyOf(getRolesLibAsync.fulfilled), (state, action) => {
        state.roleLoader = false
        state.allRolesData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(getRolesLibAsync.rejected), (state, action) => {
        state.roleLoader = false
        state.error = action.payload
      })


      // Create role
      builder.addMatcher(isAnyOf(createRoleLibAsync.pending), (state) => {
        state.roleLoader = true
      })
      builder.addMatcher(isAnyOf(createRoleLibAsync.fulfilled), (state, action) => {
        state.roleLoader = false
        state.createRoleData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(createRoleLibAsync.rejected), (state, action) => {
        state.roleLoader = false
        state.error = action.payload
      })

      //assign role
      builder.addMatcher(isAnyOf(assignRoleToGroupLibAsync.pending), (state) => {
        state.roleLoader = true
      })
      builder.addMatcher(isAnyOf(assignRoleToGroupLibAsync.fulfilled), (state, action) => {
        state.roleLoader = false
        state.assignRoleData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(assignRoleToGroupLibAsync.rejected), (state, action) => {
        state.roleLoader = false
        state.error = action.payload
      })


      // Delete role will come under this
      builder.addMatcher(isAnyOf(deleteRoleLibAsync.pending), (state) => {
        state.roleLoader = true
      })

      builder.addMatcher(isAnyOf(deleteRoleLibAsync.fulfilled), (state, action) => {
        state.roleLoader = false
        state.roleDeleteData = action.payload
      })

      builder.addMatcher(isAnyOf(deleteRoleLibAsync.rejected), (state, action) => {
        state.roleLoader = false
        state.error = action.payload
      })
  }
})

export default roleSlice.reducer
